import { z } from 'zod'

export const AddColorFormSchema = z.object({
  price: z.number().nonnegative(),
  colorHex: z.string().refine(
    (value) => {
      return !!value
    },
    {
      message: 'You have to specify a color',
    },
  ),
  // Can be null (transparent)
  backgroundColorHex: z.string().nullable(),
})

export type AddSpendColorValues = z.infer<typeof AddColorFormSchema>
